<script>

import { authComputed } from '@state/helpers'
import store from '@state/store'

export default {
	components: {
	},
	props: {
	},
	data() {
		return {}
	},
	computed: {
    ...authComputed
	},
	methods: {
    logOut: function() {
      store.dispatch('auth/logOut');
      this.$router.push({ path: '/' });
    }
	},
}
</script>

<template>

		<header class="lvc-header">

			<div class="lvc-header-bottom">
				<div class="lvc-header-bottom-container">
					<div class="lvc-header-bottom-logo">
						<a class="lvc-header-bottom-logo-link" href="https://www.lavillecasa.com.br" title="La Ville"><img src="https://lavillecasa.vteximg.com.br/arquivos/logo_lavillecasa.jpg" alt="La Ville" title="La Ville" width="130"></a>
					</div>
					<div class="lvc-header-utils">
            <div class="lvc-header-nav">
              <ul class="lvc-header-nav-list">
                <li v-if="!!currentUser"><a class="nav-list-btn" href="/minhaslistas">Minhas listas</a></li>
                <li v-if="!!currentUser"><a class="nav-list-btn" href="/instrucoes">Criar lista</a></li>
                <li v-if="!!currentUser"><a class="nav-list-btn" href="#" @click="logOut()">Sair</a></li>
              </ul>
            </div>
          </div>
				</div>
			</div>

			<div class="lvc-header-mobile">
				<div class="lvc-header-mobile-container">
					<div class="header-mobile-container-left">
						<div class="header-mobile-action">
							<svg id="Camada_2" data-name="Camada 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>mobile</title><rect width="25" height="2"></rect><rect y="7.75" width="25" height="2"></rect><rect y="15.5" width="25" height="2"></rect></svg>
						</div>
						<div class="header-mobile-logo">
							<a class="lvc-header-bottom-logo-link" href="/" title="La Ville">
								<img src="https://lavillecasa.vteximg.com.br/arquivos/logo_lavillecasa.jpg?v=637537889086270000" alt="La Ville" title="La Ville" width="130">
								<h3 class="hidden-heading">La Ville</h3>
							</a>
						</div>
					</div>
					<div class="header-mobile-container-right"></div>
				</div>
			</div>

		</header>	

</template>

<style lang="scss">

.lvc-header {
  display: flex;
  transition: transform 0.5s linear;
}
  
.lvc-header {
  width: 100vw;
  margin-top: 0;
  top: 0;
  /* alterar */
  z-index: 12;
  position: relative;
}

.lvc-header-mobile {
  display: none;
}

.lvc-header-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 30px;
  background-color: #A7A8AA;
}

.lvc-header-top-text {
  font-size: 1rem;
  color: #FFFFFF;
}

.lvc-header-bottom {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 3px 6px #00000029;
  height: 60px;
}

.lvc-header-bottom-container {
  display: flex;
  font: normal normal normal 11px/12px Roboto;
  letter-spacing: 0px;
  color: #53565a;
  align-items: center;
  width: 1440px;
  padding-right: 45px;
}

.lvc-header-bottom-logo {
  z-index: 99;
  overflow: hidden;
}

.lvc-header-bottom-logo img {
  width: 80px;
  height: 80px;
  position: relative;
  top: 4px;
  object-fit: cover;
}

.lvc-header-utils {
  margin-top: 25px;
  /*width: 100%;*/
  /*margin-left: 25px;*/
}  
  
.lvc-header-nav-list li a {
  font: normal normal 500 14px/23px Roboto;
  color: #3c3c3c; }

@media only screen and (max-width: 1480px) {
  .lvc-header-bottom-container {
    padding-left: 45px;
    padding-right: 60px;
  }
  .nav-dropdown-content-left {
    margin-left: 220px;
  }
}

@media only screen and (min-width: 769px) {
  .lvc-header-bottom {
    height: 110px;
  }
  .lvc-header-bottom-logo img {
    width: 145px;
    height: 130px;
  }
}
  

.lvc-header-nav {
  margin-left: 35px; }

.lvc-header-nav-list {
  display: flex;
  justify-content: start;
  align-items: center;
}  

.lvc-header-nav-list li { margin-right: 15px; }

</style>
